module.exports = __webpack_public_path__ + "img/contact-back116.c800da80.png";